import { defineStore } from 'pinia'

// useWebSockets could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useWebsocketsStore = defineStore('ws', {
  state: () => ({
    // TODO: Move me to a VueX Store Namespaced Module
    // Functions like:
    // Send trigger (adds project id and so on and ensure connection)
    connection: undefined as undefined | WebSocket,
    refreshTimeoutId: undefined as undefined | number,
    refreshCount: 0 as number,

    // pingTimeoutId: undefined as undefined | number,

    url: '' as string,
    reopenOnClose: true as boolean,

    onOpenPromises: [] as { (data: Event): Promise<void>; }[],
    onMessagePromises: [] as { (data: MessageEvent): Promise<void>; }[],
    onClosePromises: [] as { (data: CloseEvent): Promise<void>; }[]
  }),
  getters: {

    isConnectionOpen: (state) => {
      console.log('isConnectionOpen')
      if (!state.connection) {
        console.error('Websockets connection is falsey')
        return false
      } else if (!state.connection.readyState) {
        console.error('Websockets connection is not a WebSockets connection')
        return false
      } else if (state.connection?.readyState !== 1) {
        console.error('Websockets connection is not open/ready')
        return false
      } else return true
    }
  },
  actions: {

    debug () {
      console.log('Debug message - ' + Math.random())
    },
    disconnect () {
      this.connection?.close()
    },
    cancelNextPing () {
      clearTimeout(this.refreshTimeoutId)
    },
    connect (force: true, refreshCount: number, reopenOnClose: true) {
      if (this.connection && !force) throw new Error('Connection already open.')
      else {
        this.cancelNextPing()

        this.connection = new WebSocket(this.url)
        this.reopenOnClose = reopenOnClose

        this.connection.onopen = async (event) => {
          console.log('WS Store - Open: ', event)
          // Confusing line for - Pass event into all functions, and await ALL of the returned Promises
          await Promise.allSettled(this.onOpenPromises.map(func => func(event)))
        }

        this.connection.onmessage = async (event) => {
          console.log('WS Store - Message: ', event)
          // Confusing line for - Pass event into all functions, and await ALL of the returned Promises
          await Promise.allSettled(this.onMessagePromises.map(func => func(event)))
        }

        this.connection.onclose = async (event) => {
          console.log('WS Store - Close: ', event)
          // Confusing line for - Pass event into all functions, and await ALL of the returned Promises
          await Promise.allSettled(this.onClosePromises.map(func => func(event)))

          if (this.reopenOnClose) this.connect(force, refreshCount, reopenOnClose)
        }

        // Setup refreshes to keep connection alive
        this.refreshCount = refreshCount
        this.setupNextRefesh()
      }
    },
    setupNextRefesh () {
      // RECONNECTION TIMES
      if (this.refreshCount > 0) {
        this.refreshCount -= 1
        this.refreshTimeoutId = setTimeout(() => {
          console.log('Refresh timeout')
          this.ping()
          this.setupNextRefesh()
        }, 9.75 * 60000 /* 9.75 minutes in milliseconds */)
      }
    },
    sendMessage (data: any) {
      if (!this.isConnectionOpen) console.warn('Error sending WS Message - error above')
      else if (this.connection) this.connection.send(JSON.stringify(data))
    },
    ping () {
      if (!this.isConnectionOpen) console.warn('Error sending WS Ping - error above')
      else if (this.connection) this.connection.send(JSON.stringify({ action: 'ping' }))
    }
  }
})
